import type {
  CreatePayoutBankAccountDto,
  PayoutBankAccountDto,
  UpdatePayoutBankAccountDto,
} from '@paladin-monorepo/common';
import API from '../api';

export const payoutBankAccountsApi = {
  async list(accountId: string): Promise<PayoutBankAccountDto[]> {
    return API.get<PayoutBankAccountDto[]>(
      `/accounts/${encodeURIComponent(accountId)}/payout-bank-accounts`,
    ).then((r) => r.data);
  },

  async create(accountId: string, body: CreatePayoutBankAccountDto): Promise<PayoutBankAccountDto> {
    return API.post<PayoutBankAccountDto>(
      `/accounts/${encodeURIComponent(accountId)}/payout-bank-accounts`,
      body,
    ).then((r) => r.data);
  },

  async update(
    accountId: string,
    bankAccountId: string,
    body: UpdatePayoutBankAccountDto,
  ): Promise<PayoutBankAccountDto> {
    return API.patch<PayoutBankAccountDto>(
      `/accounts/${encodeURIComponent(accountId)}/payout-bank-accounts/${encodeURIComponent(bankAccountId)}`,
      body,
    ).then((r) => r.data);
  },

  async remove(accountId: string, bankAccountId: string): Promise<void> {
    await API.delete(
      `/accounts/${encodeURIComponent(accountId)}/payout-bank-accounts/${encodeURIComponent(bankAccountId)}`,
    );
  },

  async setPrimary(accountId: string, bankAccountId: string): Promise<PayoutBankAccountDto> {
    return API.post<PayoutBankAccountDto>(
      `/accounts/${encodeURIComponent(accountId)}/payout-bank-accounts/${encodeURIComponent(bankAccountId)}/set-primary`,
    ).then((r) => r.data);
  },
};
